import { useMutation } from '@tanstack/react-query';

import ReservationService from '~/services/ReservationService';

export interface CreateRoomRateParams {
  propertyId: string;
  ratePlanId: string;
  roomTypeId: string;
}

export function useCreateRoomRate() {
  return useMutation({
    mutationFn: ({ propertyId, ratePlanId, roomTypeId }: CreateRoomRateParams) =>
      ReservationService.createRoomRate(propertyId, roomTypeId, {
        rate_plan_id: ratePlanId,
        source: 'admin',
      }),
  });
}
